import { render } from "./prompt.vue?vue&type=template&id=c9c536d0"
import script from "./prompt.vue?vue&type=script&lang=js"
export * from "./prompt.vue?vue&type=script&lang=js"

import "./prompt.vue?vue&type=style&index=0&id=c9c536d0&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__